import { render, staticRenderFns } from "./TaxCreditLevel.vue?vue&type=template&id=4f4ba4ab&scoped=true&"
import script from "./TaxCreditLevel.vue?vue&type=script&lang=js&"
export * from "./TaxCreditLevel.vue?vue&type=script&lang=js&"
import style0 from "./TaxCreditLevel.vue?vue&type=style&index=0&id=4f4ba4ab&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ba4ab",
  null
  
)

export default component.exports